import { create } from 'zustand';

import { IContextState, IInitialState } from './interfaces';

const initialState: IInitialState = {
  active: false,
  open: false,
};

export const useMapModal = create<IContextState>((set) => ({
  ...initialState,
  setOpen: (open) => set({ open }),
  setActive: (active) => set({ active }),
  toggleOpen: () => set((state) => ({ open: !state.open })),
}));
